import { useState } from 'react';

import { Button, Divider, Modal, Skeleton } from 'antd';
import { ApartmentOutlined } from '@ant-design/icons';
import { useGetRelationGroupOverviewDetailQuery } from 'services';

import RelationInfoHeader from './relation-info-header';
import ArticleRelations from './article-relations';

function ArticleRelationShownModal({ uid }) {
  const [open, setOpen] = useState(false);

  const { data, isLoading } = useGetRelationGroupOverviewDetailQuery({ uid }, { skip: !open });

  return (
    <>
      <Button
        type="text"
        icon={<ApartmentOutlined />}
        onClick={() => setOpen(true)}
      />
      <Modal
        open={open}
        width="60%"
        onCancel={() => setOpen(false)}
        footer={null}
      >
        {isLoading || !data ? (
          <Skeleton active />
        ) : (
          <>
            <RelationInfoHeader article={data} />
            <Divider />
            <span>
              Toplam <strong>{data.relationsCount}</strong> maddeyle ilişkisi bulunmaktadır.
            </span>
            <ArticleRelations
              baseType={data.type}
              baseId={data.originalId}
            />
          </>
        )}
      </Modal>
    </>
  );
}

export default ArticleRelationShownModal;
